import type { FaireProductEntity } from "../../entity_types/product";

export const p_evqw5jrajk: FaireProductEntity = {
  token: "p_evqw5jrajk",
  type: "product",
  name: "Bakuchiol 2% Youthful Radiance Oil (1 fl oz)",
  brandToken: "b_7sxzf99szh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/28ade933685d42fc9e367de10473416881fed9547fb0ad3f41985923a6f80354.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4dc7514d3f0552247b3c172c8c9b3ef5c452bd12540da8241767afbfc1c355b1.jpeg",
    "https://cdn.faire.com/fastly/6f79bdf3123dd74b65345d17b842b3c19de80ffe6ca70c406311a8e0b683e98d.jpeg",
  ],
  priceDollars: 20.5,
  description:
    "Bakuchiol 2% Youthful Radiance Oil - A lightweight, glow-boosting facial oil designed to soften the look of fine lines, smooth texture, and support a more even-looking tone; without the dryness or sensitivity some people experience with traditional retinoids. Powered by 2% bakuchiol, this silky blend helps promote a firmer, more radiant complexion while layering beautifully under moisturizer or makeup. \n\nWhy you’ll love it:\n\n- 2% Bakuchiol: A gentle, plant-derived retinol alternative that helps improve the look of fine lines, texture, and tone.\n- Jojoba Oil: Balances and comforts skin with a non-greasy, skin-similar feel.\n- Sunflower Oil: Rich in barrier-supporting fatty acids to help lock in moisture and reduce dryness.\n- Cloudberry Oil: A luxurious antioxidant-rich oil that boosts glow and helps defend against dullness. \n\nTexture + finish Silky, lightweight, and cushiony with a dewy (not greasy) finish when applied lightly. Good for Dullness, dryness, uneven-looking tone, and early signs of aging - great for most skin types, including sensitive.\n",
  tags: [],
  msrpDollars: 41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:34.750Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
